/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingText_storyTellingTab = {
    readonly tabTitle: string;
    readonly contentHeader: string;
    readonly contentCreatorAttribution: {
        readonly creatorName: string;
        readonly creatorBrowseUrl: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null;
    readonly contentBodyText: string;
    readonly articleLink: string | null;
    readonly browseLink: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly tabType: string;
    readonly " $refType": "PdpRespStorytellingText_storyTellingTab";
};
export type PdpRespStorytellingText_storyTellingTab$data = PdpRespStorytellingText_storyTellingTab;
export type PdpRespStorytellingText_storyTellingTab$key = {
    readonly " $data"?: PdpRespStorytellingText_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingText_storyTellingTab">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "SeoLink_linkData"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespStorytellingText_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creatorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "creatorBrowseUrl",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentBodyText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "articleLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "browseLink",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};
})();
(node as any).hash = 'e223831bd8959f5d1c13328dba964342';
export default node;
